function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmgen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 218 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-235.5,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.8,17.4C360.3,13.9 356.9,11.8 352.2,11.8C344.5,11.8 338.2,18.1 338.2,25.9C338.2,33.7 344.5,40 352.2,40C357.8,40 362.6,36.7 364.8,31.9L350.4,31.9L350.4,20.3L376.8,20.3L376.8,2.3L400.3,2.3L400.3,13.9L388,13.9L388,20.3L400.3,20.3L400.3,31.9L388,31.9L388,37.9L400.3,37.9L400.3,49.2C400.7,49.2 376.8,49.2 376.8,49.2L376.8,32.2C374,45 363.7,51.6 352.2,51.6C340.8,51.6 331.2,44.8 328.5,32.9L328.5,49.4L317,49.4L317,22C317,22 310.3,27.9 310.3,49.4L298.4,49.4C298.4,27.9 291.7,22 291.7,22L291.7,49.4L280.1,49.4L280.1,1.8C293.4,1.8 302.2,16.8 304.3,25.6C306.4,16.8 315.2,1.8 328.5,1.8L328.5,17.6C330.8,7.1 341.3,0 352.3,0C363.5,0 373.4,8.5 375.5,17.4L362.8,17.4Z",
    style: {
      fill: "rgb(0,99,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,49.4C424.1,36.5 415.6,27.3 415.6,27.3L415.6,49.4L403.3,49.4L403.3,2.5C406,2.5 415.8,7.8 425.8,22.2L425.8,2.5L437.8,2.5L437.8,49.3L425.8,49.3L425.8,49.4Z",
    style: {
      fill: "rgb(0,99,195)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.7,37.6C250.4,38.9 248.3,46.1 247.5,49.4L235.5,49.4C237.1,43.5 240.2,33.4 243.5,26.6C246.7,19.9 250.7,12.5 257.4,7.5C260.5,5.2 266.4,0.7 277.4,1.7L277.4,49.4L265.8,49.4L265.8,37.6L250.7,37.6ZM265.8,26.7L265.8,15.6C262.1,18.2 258.1,23 255.7,26.7L265.8,26.7Z",
    style: {
      fill: "rgb(0,99,195)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.9,5.4C442.9,2.6 445.2,0.4 448,0.4C450.8,0.4 453,2.7 453,5.4C453,8.2 450.7,10.5 448,10.5C445.2,10.4 442.9,8.2 442.9,5.4ZM452.1,5.4C452.1,3.1 450.3,1.3 448,1.3C445.7,1.3 443.9,3.1 443.9,5.4C443.9,7.7 445.7,9.5 448,9.5C450.3,9.5 452.1,7.6 452.1,5.4ZM450.5,8.1L449.3,8.1L448.1,5.8L447,5.8L447,8.1L445.9,8.1L445.9,2.7L448.5,2.7C449,2.7 449.6,2.7 450,3C450.5,3.3 450.6,3.8 450.6,4.4C450.6,5.4 450.1,5.8 449.1,5.9L450.5,8.1ZM448.6,5C449.2,5 449.6,4.9 449.6,4.2C449.6,3.5 448.8,3.5 448.3,3.5L447,3.5L447,5L448.6,5Z",
    style: {
      fill: "rgb(0,99,195)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmgen);
export default __webpack_public_path__ + "static/media/Amgen.00c7535a9958dea010e722a8bde9c11b.svg";
export { ForwardRef as ReactComponent };